import PropTypes from 'prop-types';
import { Button, Stack, Typography } from '@mui/material';

import { componentsSize } from 'constants/components';

export const DeletedKeyEventConfirmation = ({ rowId, onConfirm, onCancel, isLoading = false }) => (
  <Stack spacing={3} id={rowId}>
    <Typography variant="subtitle1" component="p">
      Are you sure you want to delete?
    </Typography>

    <Typography variant="body1">Once you delete this key event you won’t be able to access it again.</Typography>

    <Stack direction="row" spacing={2} justifyContent="flex-end">
      <Button size={componentsSize.small} color="secondary" onClick={onCancel} disabled={isLoading}>
        Cancel
      </Button>

      <Button size={componentsSize.small} onClick={onConfirm} loading={isLoading}>
        Delete
      </Button>
    </Stack>
  </Stack>
);

DeletedKeyEventConfirmation.propTypes = {
  isLoading: PropTypes.bool,
  rowId: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};
